import { useQuery } from '@tanstack/react-query';
import { fetchProject, fetchSettings, settingsGetSettings } from '~/generated';
import { extractData } from '~/utils/query-utils';

const fetchByCategory = (category: string) => {
  if (category === 'project-settings') return fetchProject();
  if (category === 'participation') return fetchSettings();
  return settingsGetSettings({ path: { categoryKey: category } });
};

export const useSettingsByCategory = (category = 'planning') =>
  useQuery({
    queryFn: () => extractData(fetchByCategory(category)),
    queryKey: ['setting', category],
  });
